<template>
    <div class="bill-checkbox">
        <label class="input-bill-checkbox">
            <div v-if="val === '電費'">
                <img v-if="isChecked" class="bill-checkbox-img" src="@/assets/img/component/billCharge/electrict_pink.svg" alt="">
                <img v-else class="bill-checkbox-img" src="@/assets/img/component/billCharge/electrict.svg" alt="">
            </div>
            <div v-if="val === '水費'">
                <img v-if="isChecked" class="bill-checkbox-img" src="@/assets/img/component/billCharge/water_pink.svg" alt="">
                <img v-else class="bill-checkbox-img" src="@/assets/img/component/billCharge/water.svg" alt="">
            </div>
            <div v-if="val === '瓦斯費'">
                <img v-if="isChecked" class="bill-checkbox-img" src="@/assets/img/component/billCharge/gas_pink.svg" alt="">
                <img v-else class="bill-checkbox-img" src="@/assets/img/component/billCharge/gas.svg" alt="">
            </div>
            <div v-if="val === '網路費'">
                <img v-if="isChecked" class="bill-checkbox-img" src="@/assets/img/component/billCharge/network_pink.svg" alt="">
                <img v-else class="bill-checkbox-img" src="@/assets/img/component/billCharge/network.svg" alt="">
            </div>
            <div v-if="val === '有線電視'">
                <img v-if="isChecked" class="bill-checkbox-img" src="@/assets/img/component/billCharge/tv_pink.svg" alt="">
                <img v-else class="bill-checkbox-img" src="@/assets/img/component/billCharge/tv.svg" alt="">
            </div>
            <div v-if="val === '清潔費'">
                <img v-if="isChecked" class="bill-checkbox-img" src="@/assets/img/component/billCharge/clean_pink.svg" alt="">
                <img v-else class="bill-checkbox-img" src="@/assets/img/component/billCharge/clean.svg" alt="">
            </div>
            <div v-if="val === '停車費'">
                <img v-if="isChecked" class="bill-checkbox-img" src="@/assets/img/component/billCharge/parking_pink.svg" alt="">
                <img v-else class="bill-checkbox-img" src="@/assets/img/component/billCharge/parking.svg" alt="">
            </div>
            <div v-if="val === '管理費'">
                <img v-if="isChecked" class="bill-checkbox-img" src="@/assets/img/component/billCharge/manage_pink.svg" alt="">
                <img v-else class="bill-checkbox-img" src="@/assets/img/component/billCharge/manage.svg" alt="">
            </div>
            
            <input type="checkbox" :value="val" v-model="checked" @change="onChange"/>
            <div class="msg" :class="{'active': isChecked}">{{msg}}</div>
        </label>
    </div>
</template>
<script>
export default {
    data () {
        return {
            isChecked: this.isPropChecked,
            checkVal: '',
            uncheckedImgSrc: require('@/assets/img/component/billCharge/gas.svg'),
            checkedImg: require('@/assets/img/component/billCharge/gas_pink.svg'),
            uncheckedImg: require('@/assets/img/component/billCharge/gas.svg'),
        }
    },
    props: {
        msg: String,
        val: '',
        value: '',
        isPropChecked: {
            default: false,
            type: Boolean
        },
    },
    mounted () {
    },
    watch: {
        isPropChecked: {
            handler: function (newValue, oldValue) {
                this.isChecked = newValue
            },
            immediate: true
        },
    },
    computed: {
        checked: {
            get () {
                return this.value
            },
            set (val) {
                this.checkVal = val
            }
        }
    },
    methods: {
        onChange: function(e) {
            this.isChecked = !this.isChecked;
            this.$emit('input', this.checkVal)
        },
    }
}
</script>
<style lang="scss"  >
    .bill-checkbox{
        width: 56px;
        .input-bill-checkbox{
            position: relative;
            font-size: 14px;
            cursor: pointer;
            text-align: center;
            .msg {
                font-size: 14px;
                letter-spacing: normal;
                color: #a09896;
                &.active{
                    color: #ff9275;
                }
            }
            .bill-checkbox-img{
            }
            input{
                display: none;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/input/billCheckbox.vue